/**
 * GlobeNest case study: animated result counters (Google Ads + SEO results).
 */
document.addEventListener('DOMContentLoaded', function () {
    function animateCounters(selector, threshold) {
        var counters = document.querySelectorAll(selector);
        if (!counters.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                var counter = entry.target;
                var target = parseFloat(counter.getAttribute('data-target'));
                if (isNaN(target)) return;

                var isFloat = target % 1 !== 0;
                var count = 0;
                var increment = target / (2000 / 16);

                // data-decimals (SEO results) keeps the saved precision, e.g. 15.19 or 9.12
                var decimals = counter.getAttribute('data-decimals');
                var format = decimals === null
                    ? function (n, done) { return isFloat ? n.toFixed(1) : (done ? n : Math.ceil(n)).toLocaleString(); }
                    : function (n) {
                        var d = parseInt(decimals, 10) || 0;
                        return n.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
                    };

                (function update() {
                    count += increment;
                    if (count < target) {
                        counter.innerText = format(count, false);
                        requestAnimationFrame(update);
                    } else {
                        counter.innerText = format(target, true);
                    }
                })();
                observer.unobserve(counter);
            });
        }, { threshold: threshold });

        counters.forEach(function (counter) { observer.observe(counter); });
    }

    animateCounters('.gn-google-ads-results .counter', 0.2);
    animateCounters('.gn-seo-results .counter', 0.5);
});
